import { IAppState } from '../../../AppModulesWrapper';

import { TDepositAccountPaymentStatus } from '../../reducers/depositAccount';

export function selectRecommendedPackagePaymentStatus(state: IAppState): TDepositAccountPaymentStatus {
  return state.servicePickerWidget.depositAccount.recommendedPackagePaymentStatus;
}
